"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedClient = void 0;
const tslib_1 = require("tslib");
const business_constants_1 = require("@contentsquare/business-constants");
const base_client_1 = require("./base.client");
const token_storage_1 = require("../token.storage");
const errors_1 = require("../errors");
const auth_v2_client_1 = require("./auth.v2.client");
class AuthenticatedClient extends base_client_1.BaseClient {
    executeRaw(method, path, data, opts) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const axiosOpts = opts || {};
            const axiosResponse = yield this.executeCall(method, path, data, Object.assign(Object.assign({}, axiosOpts), { responseType: 'arraybuffer' }));
            if (axiosResponse.status > 299) {
                let responseData;
                try {
                    const decoder = new TextDecoder('utf8');
                    responseData = JSON.parse(decoder.decode(axiosResponse.data));
                }
                catch (e) {
                    (_a = this.settings.logger) === null || _a === void 0 ? void 0 : _a.error(`Error converting buffer to JSON ${e.message}`);
                }
                throw new errors_1.ClientError({
                    success: false,
                    errorMessage: (responseData === null || responseData === void 0 ? void 0 : responseData.errorMessage) || 'Binary response error',
                    errorCode: (responseData === null || responseData === void 0 ? void 0 : responseData.errorCode) || 'UNKNOWN_ERROR',
                });
            }
            return axiosResponse;
        });
    }
    executeCall(method, path, data, opts = {}) {
        const _super = Object.create(null, {
            executeCall: { get: () => super.executeCall }
        });
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = this.settings;
            const requestOpts = Object.assign({ headers: {} }, opts);
            const jwtToken = (_b = (_a = config.token) === null || _a === void 0 ? void 0 : _a.jwtToken) !== null && _b !== void 0 ? _b : token_storage_1.TokenStorage.get();
            if (!jwtToken) {
                throw new Error('JWT token is not available.');
            }
            requestOpts.headers.authorization = `Bearer ${jwtToken}`;
            let response;
            try {
                response = yield _super.executeCall.call(this, method, path, data, requestOpts);
                if (response.success) {
                    return response;
                }
            }
            catch (e) {
                const error = e.response;
                if (error.errorCode === business_constants_1.AuthErrorCode.JwtExpired) {
                    requestOpts.throwOnError = opts && opts.throwOnError;
                    try {
                        const refreshResult = yield this.refreshToken(jwtToken);
                        if (!refreshResult) {
                            throw new Error('Refresh token failed');
                        }
                        token_storage_1.TokenStorage.store(refreshResult);
                        if ((_c = config.token) === null || _c === void 0 ? void 0 : _c.jwtToken) {
                            config.token.jwtToken = refreshResult;
                        }
                        requestOpts.headers.authorization = `Bearer ${refreshResult}`;
                        return yield _super.executeCall.call(this, method, path, data, requestOpts);
                    }
                    catch (e) {
                        throw new errors_1.ClientError({
                            success: false,
                            errorCode: 'TOKEN_REFRESH_ERROR',
                            errorMessage: 'Refresh error',
                            payload: e,
                        });
                    }
                }
                else if (opts.throwOnError == null || opts.throwOnError) {
                    throw new errors_1.ClientError(error);
                }
            }
            return response;
        });
    }
    refreshToken(token) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = this.settings;
            let refreshedToken;
            const auth = new auth_v2_client_1.AuthV2Client(config);
            refreshedToken = (yield auth.refreshToken(token, (_a = config.token) === null || _a === void 0 ? void 0 : _a.refreshTokenId)).accessToken;
            return refreshedToken;
        });
    }
}
exports.AuthenticatedClient = AuthenticatedClient;
//# sourceMappingURL=authenticated.client.js.map